<template>
  <div>
    <!-- 搜索表单 -->
    <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
      <el-row :gutter="15">
        <el-col :md="5" :sm="12">
          <el-form-item label="日期:">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleDateChange"
              clearable
              style="width: 270px"
            />
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12">
          <el-form-item label="校部:">
            <el-select v-model="table.where.branchId" placeholder="请选择校部" clearable @change="handleBranchChange">
              <el-option v-for="item in branchList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12">
          <el-form-item label="年级:">
            <el-select v-model="table.where.gradeId" placeholder="请选择年级" clearable @change="handleGradeChange">
              <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12">
          <el-form-item label="班级:">
            <el-select v-model="table.where.classId" placeholder="请选择班级" clearable @change="handleClassChange">
              <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12">
          <el-form-item label="项目:">
            <el-select v-model="table.where.accessProjectId" placeholder="请选择项目" @change="$forceUpdate()" clearable>
              <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :md="6" :sm="12">
          <div class="ele-form-actions">
            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- 操作按钮 -->
    <div class="ele-table-tool ele-table-tool-default">
      <el-button @click="exportInfo" type="primary" icon="el-icon-download" class="ele-btn-icon" size="small">导出</el-button>
     <el-button @click="showImport = true" type="warning" icon="el-icon-upload2" class="ele-btn-icon"
        size="small">导入记录</el-button>
    </div>
    <ele-data-table ref="table" :config="table" :choose.sync="choose" row-class-name="custom-row-class" highlight-current-row>
      <template>
        <el-table-column type="selection" width="45" align="center" />
        <el-table-column type="index" width="45" align="center" />
        <el-table-column prop="studentName" label="姓名" show-overflow-tooltip align="center" />
        <el-table-column prop="studentNumber" label="学号" show-overflow-tooltip align="center" />
        <el-table-column prop="branchName" label="学部" show-overflow-tooltip align="center" />
        <el-table-column prop="gradeName" label="年级" show-overflow-tooltip align="center" />
        <el-table-column prop="className" label="班级" show-overflow-tooltip align="center" />
        <el-table-column prop="accessProjectName" label="项目" show-overflow-tooltip align="center" />
        <el-table-column prop="accessItemName" label="细则" show-overflow-tooltip align="center" />
        <el-table-column prop="itemType" label="属性" show-overflow-tooltip align="center" width="60">
          <template slot-scope="{ row }">
            {{ row.itemType == 1 ? '加分' : row.itemType == 2 ? '减分' : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="studentScore" label="分值" show-overflow-tooltip align="center" width="50">
          <template slot-scope="{ row }">
            <span :style="{ color: row.studentScore > 0 ? '#409EFF' : row.studentScore < 0 ? '#F56C6C' : '', fontWeight: 'bold' }">
              {{ row.studentScore }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createDay" label="录入日期" show-overflow-tooltip align="center" />
        <el-table-column prop="createUser" label="录入人" show-overflow-tooltip align="center" />
        <el-table-column prop="remark" label="备注" show-overflow-tooltip align="center" />
      </template>
    </ele-data-table>
   <!-- 导入记录弹窗 -->
    <el-dialog title="导入量化记录" :visible.sync="showImport" width="460px" :destroy-on-close="true" :lock-scroll="false"
      @opened="onImportOpen">
      <el-form label-width="80px" style="padding: 0 20px 10px">
        <el-form-item label="项目:" required>
          <el-select v-model="importForm.accessProjectId" placeholder="请选择项目" style="width: 100%"
            @change="handleImportProjectChange">
            <el-option v-for="item in importProjectList" :key="item.id" :label="item.projectName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="细则:" required>
          <el-select v-model="importForm.accessItemId" placeholder="请选择细则" style="width: 100%">
            <el-option v-for="item in importItemList" :key="item.id" :label="item.itemName" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <el-upload v-loading="uploadLoading" :action="$http.defaults.baseURL + '/yzdAccess/importAccess'"
        :data="uploadData" accept=".xls,.xlsx" :headers="$http.defaults.headers.common"
        :before-upload="beforeImportUpload" class="ele-block" :on-success="handleImportSuccess"
        :on-error="handleImportError" :show-file-list="false" drag>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
        <div class="el-upload__tip ele-text-center" slot="tip">
          只能上传xls、xlsx文件，
          <el-link type="primary" :underline="false" :href="importTplUrl" download
            style="vertical-align: baseline">下载模板</el-link>
        </div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
import { exportAccessRecord, selectionList, adminAccessProjectSelect, getAccessItemList } from '@/config/yizhongDong/examine';

  export default {
    name: 'Personal',
    data() {
      return {
        table: {
          // 表格配置
          url: '/yzdAccess/adminAccessRecordPage',
          method: 'GET',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [],
        branchList: [],
        gradeList: [],
        classList: [],
        projectList: [],
        date: null,
        showImport: false,
        uploadLoading: false,
        importTplUrl: 'https://hdsys.oss-cn-beijing.aliyuncs.com/hdjxt/template/1782872420932/校级量化记录导入.xlsx',
        importForm: {
          accessProjectId: undefined,
          accessItemId: undefined,
        },
        importProjectList: [],
        importItemList: [],
      };
  },
  computed: {
    // 上传时附带的参数
    uploadData () {
      return {
        itemId: this.importForm.accessItemId,
      };
    },
    },
    created() {
      // 初始化加载校部列表
      this.loadBranchList();
      this.loadProjectList();
    },
    methods: {
      // 加载校部列表
      async loadBranchList() {
        try {
          const res = await selectionList({ type: 1, projectType: 2 });
          if (res.data.resCode == 200) {
            this.branchList = res.data.data || [];
          }
        } catch (error) {
          console.error('加载校部列表失败:', error);
        }
      },
      // 加载年级列表
      async loadGradeList(branchId) {
        if (!branchId) {
          this.gradeList = [];
          return;
        }
        try {
          const res = await selectionList({ type: 2, projectType: 2, id: branchId });
          if (res.data.resCode == 200) {
            this.gradeList = res.data.data || [];
          }
        } catch (error) {
          console.error('加载年级列表失败:', error);
        }
      },
      // 加载班级列表
      async loadClassList(gradeId) {
        if (!gradeId) {
          this.classList = [];
          return;
        }
        try {
          const res = await selectionList({ type: 4, projectType: 2, id: gradeId });
          if (res.data.resCode == 200) {
            this.classList = res.data.data || [];
          }
        } catch (error) {
          console.error('加载班级列表失败:', error);
        }
      },
      // 加载项目列表
      async loadProjectList(classId) {
        try {
          const params = classId ? { classId: classId } : {};
          const res = await adminAccessProjectSelect(params);
          if (res.data.resCode == 200) {
            this.projectList = res.data.data || [];
          }
        } catch (error) {
          console.error('加载项目列表失败:', error);
        }
      },
      // 选择校部时
      handleBranchChange(branchId) {
        // 清空下级选项
        this.table.where.gradeId = undefined;
        this.table.where.classId = undefined;
        this.table.where.accessProjectId = undefined;
        this.gradeList = [];
        this.classList = [];
        this.projectList = [];

        // 加载年级列表
        if (branchId) {
          this.loadGradeList(branchId);
        }
      },
      // 选择年级时
      handleGradeChange(gradeId) {
        // 清空下级选项
        this.table.where.classId = undefined;
        this.table.where.accessProjectId = undefined;
        this.classList = [];
        this.projectList = [];

        // 加载班级列表
        if (gradeId) {
          this.loadClassList(gradeId);
        }
      },
      // 选择班级时
      handleClassChange(classId) {
        // 清空项目选项
        this.table.where.accessProjectId = undefined;
        this.projectList = [];

        // 加载项目列表
        if (classId) {
          this.loadProjectList(classId);
        }
      },
      // 日期选择
      handleDateChange(value) {
        this.table.where.startTime = value[0];
        this.table.where.endTime = value[1];
      },
      // 重置表单
      handleReset() {
        this.table.where = {};
        this.date = null;
        this.gradeList = [];
        this.classList = [];
        this.projectList = [];
        this.$refs.table.reload();
      },
      // 导出数据
      exportInfo() {
        exportAccessRecord(this.table.where).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
      // 导入弹窗打开时加载项目列表
      onImportOpen () {
        this.importForm = { accessProjectId: undefined, accessItemId: undefined };
        this.importItemList = [];
        this.loadImportProjectList();
      },
      // 加载导入弹窗的项目列表
      async loadImportProjectList () {
        try {
          const res = await adminAccessProjectSelect({});
          if (res.data.resCode == 200) {
            this.importProjectList = res.data.data || [];
          }
        } catch (error) {
          console.error('加载项目列表失败:', error);
        }
      },
      // 导入弹窗中选择项目时加载细则
      async handleImportProjectChange (projectId) {
        this.importForm.accessItemId = undefined;
        this.importItemList = [];
        if (!projectId) return;
        try {
          const res = await getAccessItemList({ projectId: projectId });
          if (res.data.resCode == 200) {
            this.importItemList = res.data.data || [];
          }
        } catch (error) {
          console.error('加载细则列表失败:', error);
        }
      },
      // 上传前校验
      beforeImportUpload () {
        if (!this.importForm.accessProjectId) {
          this.$message.error('请先选择项目');
          return false;
        }
        if (!this.importForm.accessItemId) {
          this.$message.error('请先选择细则');
          return false;
        }
        this.uploadLoading = true;
        return true;
      },
      // 导入成功回调
      handleImportSuccess (res) {
        this.uploadLoading = false;
        if (res.resCode == '200' || res.resCode == 200) {
          this.showImport = false;
          const data = res.data || {};
          const { totalCount = 0, successCount = 0, failCount = 0, errors = [] } = data;
          if (failCount > 0) {
            // 有部分失败，展示错误明细
            const errorLines = errors.map((e) => `<div style="margin: 3px 0">第 <b>${e.rowNum}</b> 行：${e.message}</div>`).join('');
            const msg = `
              <div style="margin-bottom: 8px; font-size: 14px">
                共 <b>${totalCount}</b> 条，成功 <b style="color:#67C23A">${successCount}</b> 条，失败 <b style="color:#F56C6C">${failCount}</b> 条
              </div>
              <div style="border-top: 1px solid #eee; padding-top: 8px">${errorLines}</div>
            `;
            this.$notify({
              title: '导入结果',
              dangerouslyUseHTMLString: true,
              message: msg,
              type: 'warning',
              duration: 0,
            });
          } else {
            this.$message({ type: 'success', message: `导入成功，共 ${successCount} 条`, duration: 3000 });
          }
          this.$refs.table.reload();
        } else {
          this.$message.error(res.resMsg || '导入失败');
        }
      },
      // 导入失败回调
      handleImportError () {
        this.uploadLoading = false;
        this.$message.error('上传失败，请检查网络后重试');
      },
      //重置表单
      resetForm() {
        this.editForm = {
          branchId: undefined,
          gradeId: undefined,
          classId: undefined,
          accessProjectId: undefined,
          accessItemId: undefined,
          studentId: undefined,
          studentName: '',
          createDay: undefined,
          createUser: '',
          studentNumber: '',
          remark: '',
          photos: [],
        };
        this.fileList = [];
        this.$refs['editForm'].resetFields();
      },
    },
  };
</script>

<style scoped>
.ele-block>>>.el-upload,
.ele-block>>>.el-upload-dragger {
  width: 100%;
}
</style>
